import { useState, useEffect, useContext, useRef, useCallback, useMemo } from 'react'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import qs from 'qs'
import { Prompt } from 'react-router-dom';
import { MainLayout, PublicLayout } from '../layouts'
import {
    SingleDocumentSidebar,
    SingleDocumentMain,
    SingleDocumentSidePanel,
    AgencyModal,
    NotariesModal,
    AddEditNotaryModal,
    PublicDocumentSidebar,
} from '../components/misc'
import { ResponseLoader, ResourceNotFound, Alert } from '../components/ui_new'
import {
    FileAlt2,
} from '../assets/icons'
import {
    DocumentsContext,
    NotificationContext,
    UserContext,
    LoaderContext,
    SingleDocumentContext,
    ValidationContext,
    RegisteredMailContext,
} from '../context'
import {
    fetch_document_history,
    fetch_document_data,
    fetch_document_events,
} from '../services/firestore'
import { useAgencyActions, useSingleDocumentActions, useVariablesActions } from '../hooks'
import { FEATURE, VALIDATION_TIMESTAMPS_COOKIE_NAME, areArraysEqual, areObjectsEqual, areSectionConditionsMet, buildContentChanges, convertToTemplateObjWithUniqueVarIndexes, deconstructContentChanges, expandTemplateWithClauses, getActiveContactsFromData, isFeatureEnabled, prefillValuesWithAdminData } from '../utils'
import {
    TEXT_LINES,
    TEXTAREA_LINES,
    DATE_LINES,
    NUMBER_LINES,
    CONTACT_ID_VARIABLES,
    VALIDATION_STATUS,
} from '../constants'
import config from '../config.json'
import { isMobile } from 'react-device-detect'
import { AttachmentsContext } from '../context/attachments/attachmentsState';
import byteConverter from '../helpers/byteConverter';
import { useCookies } from 'react-cookie';
import { SIGNATURE_MODE_FOR_TEMPLATE } from '../utils/vialink';
import SingleDocumentSignVialink from '../components/misc/SingleDocumentSignVialink';
import { ArrowBack } from '@mui/icons-material';
import SingleDocumentShareV2 from '../components/misc/SingleDocumentShareV2';

let scrollToItemTimeout = null
const arrayStack = [-Infinity]


const excludedProgressVars = [...CONTACT_ID_VARIABLES]

const SingleDocument = ({ token, layout }) => {

    const Layout = layout === 'public' ? PublicLayout : MainLayout
    const location = useLocation();
    const {
        documents,
        documentsLoaded,
        templates,
        templatesLoaded,
        getSingleTemplate,
        updateDocument,
        createDocument,
        createStandardTemplate,
        archivedDocuments,
        deletedDocuments,
        clauses,
        clausesLoaded
    } = useContext(DocumentsContext)
    const { setNotification } = useContext(NotificationContext)
    const { partner, user, agency, signInResult, integration, authError } = useContext(UserContext)
    const { setShowGlobalResponseLoader, setGlobalResponseLoaderText } =
        useContext(LoaderContext)
    const { setPrefilledAttachmentVariable } = useContext(AttachmentsContext)
    const { showValidationWarning, closeValidationWarning, validationsFetched } = useContext(ValidationContext)
    const { createAr24MailRequestFromDocument } = useContext(RegisteredMailContext)
    const {
        getDocumentHistory,
        getDocumentEventsDayArray,
        joinValues,
        getPreviewData,
        // progress,
        allVariables,
        getCustomersFromData,
        extractCustomerData,
    } = useSingleDocumentActions()

    const { isTemplateValidationRequired } = useAgencyActions()

    const [cookies, setCookie] = useCookies()

    const [documentId, setDocumentIdState] = useState('')
    const [singleDoc, setSingleDoc] = useState(null)
    const [singleDocReady, setSingleDocReady] = useState(false)
    const [singleDocNotFound, setSingleDocNotFound] = useState(false)
    const [singleDocArchived, setSingleDocArchived] = useState(false)
    const [singleDocDeleted, setSingleDocDeleted] = useState(false)
    const [singleDocHistory, setSingleDocHistory] = useState(null)
    const [singleDocEvents, setSingleDocEvents] = useState(null)
    const [singleDocName, setSingleDocName] = useState('')
    const [singleDocStatus, setSingleDocStatus] = useState('')
    const [singleDocAssignedTo, setSingleDocAssignedTo] = useState(null)
    // const [historyFetched, setHistoryFetched] = useState(false)
    const [scrollingToItem, setScrollingToItem] = useState(false)
 
    const [templateFetching, setTemplateFetching] = useState(false)
    const [documentGettingReady, setDocumentGettingReady] = useState(false)
    const [templateNotFound, setTemplateNotFound] = useState(false)
    const [documentCheckboxValues, setDocumentCheckboxValues] = useState({})
    const [useCustomCover, setUseCustomCover] = useState(false)
    const [linesAdded, setLinesAdded] = useState(false)
    const [sidePanelOpenStatus, setSidePanelOpenStatus] = useState({
        'variables': true,
        'attachments': false,
    })
    const [pdfPreviewData, setPdfPreviewData] = useState(null)
    const [previewLoading, setPreviewLoading] = useState(true)
    const [contentChangesHistory, setContentChangesHistory] = useState([[]])
    const [contentChangesHistoryIndex, setContentChangesHistoryIndex] = useState(0)
    const [activeTab, setActiveTab] = useState('summary')
    const [templateObject, setTemplateObject] = useState(null)
    const [documentContacts, setDocumentContacts] = useState([])
    const [activeDocumentContacts, setActiveDocumentContacts] = useState([])
    const [docSignatureRecipients, setDocSignatureRecipients] = useState([])
    const [currentDocVersionTime, setCurrentDocVersionTime] = useState({})
    const [view, setView] = useState('variables')
    const [showAgencyModal, setShowAgencyModal] = useState(false)
    const [showNotariesModal, setShowNotariesModal] = useState(false)
    const [showAddEditNotaryModal, setShowAddEditNotaryModal] =
        useState(false)
    const [notaryMode, setNotaryMode] = useState('add')
    const [selectedNotary, setSelectedNotary] = useState(null)
    const [isTemplatePage, setIsTemplatePage] = useState(false)
    const { setIsScroll, isScroll } =
        useContext(UserContext)
    const [showMoreActions, setShowMoreActions] = useState(false)
    const [previewSettings, setPreviewSettings] = useState(null) // initialize with null so that initial preview uses document settings
    const [lastPreviewSnapshot, setLastPreviewSnapshot] = useState(null)
    const [showEditionWarningModal, setShowEditionWarningModal] = useState(false)
    const params = useParams()
    const history = useHistory()
    const bodyWrapEl = useRef()

    // feat/editable-content-lite
    const [isContentEditableState, setIsContentEditable] = useState(null)
    const isContentEditable = isFeatureEnabled(FEATURE.EDITABLE_CONTENT_LITE, integration) ? isContentEditableState : false

    // meta sections - for repeatable / conditional content
    const [templateMetaSections, setTemplateMetaSections] = useState([])
    const [summarySections, setSummarySections] = useState([])


    // share update
    const [shareAttachments, setShareAttachments] = useState([])
    const [showShareModal, setShowShareModal] = useState(false)

    const [showSignModal, setShowSignModal] = useState(false)

    const [progress, setProgress] = useState(0)

    const previewLoadingRef = useRef(null)
    const shouldRecordContentHistoryRef = useRef(false)

    const {
        documentValues,
        setDocumentValues,
        setDocument,
        setDocumentId,
        templateObjectWithUniqueVarIndexes,
        setTemplateObjectWithUniqueVarIndexes,
        filteredDefaultAttachments,
        documentAttachments,
        filteredDocumentAttachments,
        setDocumentAttachments,
        enableValidationMode,
        activeValidation,
        openValidationModal,
        revisionModeEnabled,
        disableValidationMode,
        handleDocumentDownload,
        partialContentChanges,
        setPartialContentChanges,
        addPartialContentChange,
    } = useContext(SingleDocumentContext)

    const templateWithClauses = useMemo(() => {
        if (!templateObject) return null
        return expandTemplateWithClauses(templateObject, clauses)
    }, [templateObject, clauses])

    const normalizePreviewValue = useCallback((value) => {
        if (Array.isArray(value)) {
            return value.map(normalizePreviewValue)
        }
        if (value && typeof value === 'object') {
            const normalized = {}
            Object.keys(value).sort().forEach((key) => {
                normalized[key] = normalizePreviewValue(value[key])
            })
            return normalized
        }
        return value
    }, [])

    const buildPreviewSnapshot = useCallback(({
        values,
        checkboxValues,
        useCustomCoverValue,
        linesAddedValue,
        previewSettingsValue,
        isContentEditableValue,
        partialContentChangesValue,
    }) => ({
        values: normalizePreviewValue(values || {}),
        checkboxValues: normalizePreviewValue(checkboxValues || {}),
        useCustomCover: Boolean(useCustomCoverValue),
        linesAdded: Boolean(linesAddedValue),
        previewSettings: normalizePreviewValue(previewSettingsValue || {}),
        isContentEditable: Boolean(isContentEditableValue),
        partialContentChanges: normalizePreviewValue(partialContentChangesValue || []),
    }), [normalizePreviewValue])

    const currentPreviewSnapshot = useMemo(() => buildPreviewSnapshot({
        values: documentValues,
        checkboxValues: documentCheckboxValues,
        useCustomCoverValue: useCustomCover,
        linesAddedValue: linesAdded,
        previewSettingsValue: previewSettings,
        isContentEditableValue: isContentEditable,
        partialContentChangesValue: partialContentChanges,
    }), [
        buildPreviewSnapshot,
        documentValues,
        documentCheckboxValues,
        useCustomCover,
        linesAdded,
        previewSettings,
        isContentEditable,
        partialContentChanges,
    ])

    const isPreviewUpToDate = Boolean(lastPreviewSnapshot && areObjectsEqual(lastPreviewSnapshot, currentPreviewSnapshot))

    const activeValidationRef = useRef(activeValidation)

    useEffect(() => {
        activeValidationRef.current = activeValidation
    }, [activeValidation])


    useEffect(() => {
        if(layout === 'public') {
            enableValidationMode()
        }
    }, [layout, enableValidationMode])

    useEffect(() => {
        if(!activeValidation) return
        const lastValidationTimestampPerValidation = cookies[VALIDATION_TIMESTAMPS_COOKIE_NAME] || {}
        // const currentTimestamp = Date.now()

        const currentTimestamp = Date.now()
        // const timeDiff = currentTimestamp - lastValidationTimestamp
        // if(timeDiff > 1000 * 60 * 5) { 
        //   setCookie(VALIDATION_TIMESTAMP_COOKIE_NAME, Date.now(), { path: '/' })
        // }
        // if(timeDiff > 1000 * 60 * 5) { 
          setCookie(VALIDATION_TIMESTAMPS_COOKIE_NAME, {
            ...lastValidationTimestampPerValidation,
            [activeValidation.id]: currentTimestamp
          }, { path: '/' })
        // }
    }, [activeValidation])


    useEffect(() => {
        const activeContacts = getActiveContactsFromData(documentValues)
        setActiveDocumentContacts(activeContacts)
    }, [documentValues])

    useEffect(() => {
        if(!singleDoc) return
        if(singleDoc.custom_cover !== undefined) return
        setUseCustomCover(singleDoc.custom_cover ?? agency?.cover_page_default ?? true)
    }, [agency, singleDoc])

    useEffect(() => {

        if (!templateObjectWithUniqueVarIndexes) {
            return
        }

        const extractMetaBlocks = (sections) => {

            // Array.prototype.last = function() {
            //     return this[this.length - 1]
            // }

            const metaSections = []
            const currentMetaSectionStack = [{
                sections: [],
                repeatableIds: [],
                isMetaSection: true
            }]
            for (let i = 0; i < sections.length; i++) {
                const section = sections[i]
                section.index = i
                const sectionRepeatableIds = section.repeatable_section_ids || (section.repeatable_section_id ? [section.repeatable_section_id] : [])
                // check if section is sibling or direct child of current_full
                if (currentMetaSectionStack.length === 0) {
                    const newMetaSection = {
                        sections: [section],
                        repeatableIds: sectionRepeatableIds,
                        isMetaSection: true
                    }
                    currentMetaSectionStack.push(newMetaSection)
                } else if (areArraysEqual(sectionRepeatableIds, currentMetaSectionStack[currentMetaSectionStack.length - 1].repeatableIds)) {
                    currentMetaSectionStack[currentMetaSectionStack.length - 1].sections.push(section)
                } else if (sectionRepeatableIds.length > currentMetaSectionStack[currentMetaSectionStack.length - 1].repeatableIds.length) {
                    // validate if section is direct child of current
                    if (sectionRepeatableIds.length === currentMetaSectionStack[currentMetaSectionStack.length - 1].repeatableIds.length + 1 && currentMetaSectionStack[currentMetaSectionStack.length - 1].repeatableIds.length > 0 && areArraysEqual(sectionRepeatableIds.slice(0, currentMetaSectionStack[currentMetaSectionStack.length - 1].repeatableIds.length), currentMetaSectionStack[currentMetaSectionStack.length - 1].repeatableIds)) {
                        const newMetaSection = {
                            sections: [section],
                            repeatableIds: sectionRepeatableIds,
                            isMetaSection: true
                        }
                        currentMetaSectionStack.push(newMetaSection)
                    } else if (currentMetaSectionStack[currentMetaSectionStack.length - 1].repeatableIds.length === 0) {

                        const lastMetaSection = currentMetaSectionStack.pop()
                        if (lastMetaSection.sections.length > 0) {
                            metaSections.push(lastMetaSection)
                        }
                        const newMetaSection = {
                            sections: [section],
                            repeatableIds: sectionRepeatableIds,
                            isMetaSection: true
                        }
                        currentMetaSectionStack.push(newMetaSection)
                    } else {
                        throw new Error('Invalid section repeatable ids')
                    }
                } else if (sectionRepeatableIds.length < currentMetaSectionStack[currentMetaSectionStack.length - 1].repeatableIds.length) {
                    // jump out of current stack until we find a matching parent 
                    while (currentMetaSectionStack.length > 0 && (sectionRepeatableIds.length < currentMetaSectionStack[currentMetaSectionStack.length - 1].repeatableIds.length)) {
                        const closingSection = currentMetaSectionStack.pop()
                        if (currentMetaSectionStack.length === 0) {
                            metaSections.push(closingSection)
                        } else {
                            currentMetaSectionStack[currentMetaSectionStack.length - 1].sections.push(closingSection)
                        }
                    }
                    if (currentMetaSectionStack.length > 0) {
                        // check if last in stack is same as current or parent of current, if not, close it and create new
                        while (currentMetaSectionStack.length > 0 && !areArraysEqual(sectionRepeatableIds.slice(0, currentMetaSectionStack[currentMetaSectionStack.length - 1].repeatableIds.length), currentMetaSectionStack[currentMetaSectionStack.length - 1].repeatableIds)) {
                            const closingSection = currentMetaSectionStack.pop()
                            if (currentMetaSectionStack.length === 0) {
                                metaSections.push(closingSection)
                            } else {
                                currentMetaSectionStack[currentMetaSectionStack.length - 1].sections.push(closingSection)
                            }
                        }
                        if (currentMetaSectionStack.length > 0 && areArraysEqual(sectionRepeatableIds, currentMetaSectionStack[currentMetaSectionStack.length - 1].repeatableIds)) {
                            currentMetaSectionStack[currentMetaSectionStack.length - 1].sections.push(section)
                        } else {
                            const newMetaSection = {
                                sections: [section],
                                repeatableIds: sectionRepeatableIds,
                                isMetaSection: true
                            }
                            currentMetaSectionStack.push(newMetaSection)
                        }
                    } else {
                        const newMetaSection = {
                            sections: [section],
                            repeatableIds: sectionRepeatableIds,
                            isMetaSection: true
                        }
                        currentMetaSectionStack.push(newMetaSection)
                    }
                } else {
                    // are equal length but not equal
                    const closingSection = currentMetaSectionStack.pop()
                    if (currentMetaSectionStack.length === 0) {
                        metaSections.push(closingSection)
                    } else {
                        currentMetaSectionStack[currentMetaSectionStack.length - 1].sections.push(closingSection)
                    }
                    const newMetaSection = {
                        sections: [section],
                        repeatableIds: sectionRepeatableIds,
                        isMetaSection: true
                    }
                    currentMetaSectionStack.push(newMetaSection)
                }
            }
            while (currentMetaSectionStack.length > 0) {
                const closingSection = currentMetaSectionStack.pop()
                if (currentMetaSectionStack.length === 0) {
                    metaSections.push(closingSection)
                } else {
                    currentMetaSectionStack[currentMetaSectionStack.length - 1].sections.push(closingSection)
                }
            }
            return metaSections
        }

        // const mSections = extractMetaBlocks(templateObjectWithUniqueVarIndexes.sections)

        // insert clauses in place of clause type sections
        // replace sections where section.type === clause with clause.sections
        const sectionsWithClauses = []
        templateObjectWithUniqueVarIndexes.sections.forEach((section) => {
            if(section.type !== 'clause') {
                sectionsWithClauses.push(section)
                return
            }
            const clause = clauses[section.clause_id]
            if(!clause) {
                return
            }
            sectionsWithClauses.push(...(clause.sections.map((clauseItem) => ({
                ...clauseItem,
                repeatable_section_ids: [...(section.repeatable_section_ids || []), ...(clauseItem.repeatable_section_ids || [])],
            }))))            
        })
        const mSections = extractMetaBlocks(sectionsWithClauses)

        setTemplateMetaSections(mSections)
        // return []
        // return metaSections

    }, [templateObjectWithUniqueVarIndexes, clauses])

    const { duplicatableValuesArray, value } = useVariablesActions({ values: documentValues })

    useEffect(() => {
        if (!templateMetaSections) {
            return
        }

        const extractSummaryRowsFromMetaSection = (metaSection, parentRepeatableIds, parentRepetitionIndices) => {
            const rows = []
            const { sections } = metaSection
            if (metaSection.repeatableIds && metaSection.repeatableIds.length > 0) {
                const repetitionValuesArray = duplicatableValuesArray([...(metaSection.repeatableIds || [])], parentRepetitionIndices)
                if (!repetitionValuesArray || repetitionValuesArray.length === 0) return []
                repetitionValuesArray.forEach((repetitionValues, repetitionIndex) => {
                    for (let i = 0; i < sections.length; i++) {
                        const subSection = sections[i]
                        if (subSection.isMetaSection) {
                            const subSectionRows = extractSummaryRowsFromMetaSection(subSection, [...(metaSection.repeatableIds || [])], [...(parentRepetitionIndices || []), repetitionIndex])
                            rows.push(...subSectionRows)
                            continue
                        }
                        if (!areSectionConditionsMet({ ...subSection, repetitionIndices: [...(parentRepetitionIndices || []), repetitionIndex] }, documentValues)) {
                            continue
                        }
                        if (subSection.type.startsWith('heading')) {
                            rows.push({
                                title: subSection.content,
                                repeatableIds: metaSection.repeatableIds,
                                repetitionIndices: [...(parentRepetitionIndices || []), repetitionIndex],
                            })
                        }
                        if (subSection.variable) {
                            const row = { variable: subSection, repeatableIds: metaSection.repeatableIds, repetitionIndices: [...(parentRepetitionIndices || []), repetitionIndex] }
                            if (row.variable) {
                                row.value = repetitionValues[row.variable.variable]
                            }
                            rows.push(row)
                        }
                        if (subSection.variables) {
                            const variables = subSection.variables
                            for (let j = 0; j < variables.length; j++) {
                                const variable = variables[j]
                                const row = { variable, repeatableIds: metaSection.repeatableIds, repetitionIndices: [...(parentRepetitionIndices || []), repetitionIndex] }
                                if (row.variable) {
                                    row.value = repetitionValues[row.variable.variable]
                                }
                                rows.push(row)
                            }
                        }
                    }
                })

            } else {
                for (let i = 0; i < sections.length; i++) {
                    const subSection = sections[i]
                    if (subSection.isMetaSection) {
                        const subSectionRows = extractSummaryRowsFromMetaSection(subSection, [...(metaSection.repeatableIds || [])], parentRepetitionIndices)
                        rows.push(...subSectionRows)
                        continue
                    }
                    if (!areSectionConditionsMet({ ...subSection, repetitionIndices: parentRepetitionIndices }, documentValues)) {
                        continue
                    }
                    if (subSection.type.startsWith('heading')) {
                        rows.push({
                            title: subSection.content,
                            repeatableIds: metaSection.repeatableIds,
                            repetitionIndices: parentRepetitionIndices,
                        })
                    }
                    if (subSection.variable) {
                        const row = { variable: subSection, repeatableIds: metaSection.repeatableIds, repetitionIndices: parentRepetitionIndices }
                        if (row.variable) {
                            row.value = documentValues[row.variable.variable]
                        }
                        rows.push(row)
                    }
                    if (subSection.variables) {
                        const variables = subSection.variables
                        for (let j = 0; j < variables.length; j++) {
                            const variable = variables[j]
                            const row = { variable, repeatableIds: metaSection.repeatableIds, repetitionIndices: parentRepetitionIndices }
                            if (row.variable) {
                                row.value = documentValues[row.variable.variable]
                            }
                            rows.push(row)
                        }
                    }
                }
            }
            return rows
        }

        const rows = templateMetaSections.map((metaSection, metaSectionIndex) => extractSummaryRowsFromMetaSection(metaSection, [], []))
        const rowsFull = rows.flat()

        const sections = []
        let currentSummarySection = { title: '', fields: [] }
        for (let i = 0; i < rowsFull.length; i++) {
            const row = rowsFull[i]
            if (row.title) {
                if (currentSummarySection.fields.length > 0 || currentSummarySection.title) {
                    sections.push(currentSummarySection)
                }
                currentSummarySection = {
                    title: row.title,
                    fields: [],
                    repeatableIds: row.repeatableIds,
                    repetitionIndices: row.repetitionIndices,
                }
            } else if (row.variable) {
                currentSummarySection.fields.push({ ...row.variable, value: row.value, repeatableIds: row.repeatableIds, repetitionIndices: row.repetitionIndices })
            }
        }
        if (currentSummarySection.fields.length > 0 || currentSummarySection.title) {
            sections.push(currentSummarySection)
        }

        let totalProgress = 0
        let variablesTotal = 0
        let variablesDone = 0
        for (let i = 0; i < sections.length; i++) {
            const section = sections[i]
            const fields = section.fields
            let sectionVariablesTotal = 0
            let sectionVariablesDone = 0
            for (let j = 0; j < fields.length; j++) {
                const field = fields[j]
                if (field.variable && !excludedProgressVars.includes(field.variable)) {
                    sectionVariablesTotal++
                    if (field.value !== null && typeof field.value !== undefined && ((typeof field.value === 'string' && field.value !== '') || (typeof field.value === 'number' && !isNaN(field.value)))) {
                        sectionVariablesDone++
                    }
                }
            }
            if (sectionVariablesTotal > 0) {
                section.progress = Math.round((sectionVariablesDone / sectionVariablesTotal) * 100)
            }
            variablesTotal += sectionVariablesTotal
            variablesDone += sectionVariablesDone
        }
        totalProgress = variablesTotal > 0 ? (variablesDone / variablesTotal) : 1
        setProgress(totalProgress)
        setSummarySections(sections)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [templateMetaSections, documentValues])

    const handleToggleContentEditable = () => {
        if (!isContentEditable) {
            setShowEditionWarningModal(true)
        }
        setIsContentEditable(!isContentEditable)
    }

    useEffect(() => {
        if (!templateWithClauses) return
        if (!singleDoc) return
        if(!templateWithClauses.sections) return

        const copyOfTemplate = convertToTemplateObjWithUniqueVarIndexes({ ...templateWithClauses })
        setTemplateObjectWithUniqueVarIndexes(copyOfTemplate);
    }, [singleDoc, templateWithClauses, setTemplateObjectWithUniqueVarIndexes])

    const partialContentChangeKey = useCallback((change) => {
        const sectionIdxKey = change.sectionIdx === undefined || change.sectionIdx === null ? '' : String(change.sectionIdx)
        const hasItemIndex = typeof change.itemIndex === 'number' && change.itemIndex >= 0
        const hasOccurrenceIndex = typeof change.occurrenceIndex === 'number' && change.occurrenceIndex >= 0
        const fragmentKey = hasItemIndex
            ? `item:${change.itemIndex}`
            : hasOccurrenceIndex
                ? `occ:${change.occurrenceIndex}:${change.originalContent || ''}`
                : `raw:${change.originalContent || ''}`
        return `${change.sectionIndex}_${change.listIndex}_${sectionIdxKey}_${fragmentKey}`
    }, [])

    const clonePartialContentChanges = useCallback((changes = []) => {
        if (!Array.isArray(changes)) {
            return []
        }
        return changes.map((change) => ({ ...change }))
    }, [])

    const resetContentChangesHistory = useCallback((changes = []) => {
        const snapshot = clonePartialContentChanges(changes)
        setContentChangesHistory([snapshot])
        setContentChangesHistoryIndex(0)
    }, [clonePartialContentChanges])

    useEffect(() => {
        if (!shouldRecordContentHistoryRef.current) {
            return
        }
        shouldRecordContentHistoryRef.current = false
        setContentChangesHistory((prevHistory) => {
            const currentHistory = Array.isArray(prevHistory) && prevHistory.length > 0 ? prevHistory : [[]]
            const truncatedHistory = currentHistory.slice(0, contentChangesHistoryIndex + 1)
            const nextSnapshot = clonePartialContentChanges(partialContentChanges)
            const nextHistory = [...truncatedHistory, nextSnapshot]
            setContentChangesHistoryIndex(nextHistory.length - 1)
            return nextHistory
        })
    }, [partialContentChanges, contentChangesHistoryIndex, clonePartialContentChanges])

    const onSectionContentChanged = (change) => {
        shouldRecordContentHistoryRef.current = true
        addPartialContentChange(change)
    }

    const handleUndoContentChanges = useCallback(() => {
        if (contentChangesHistoryIndex <= 0) {
            return
        }
        const nextIndex = contentChangesHistoryIndex - 1
        setContentChangesHistoryIndex(nextIndex)
        setPartialContentChanges(clonePartialContentChanges(contentChangesHistory[nextIndex] || []))
    }, [clonePartialContentChanges, contentChangesHistory, contentChangesHistoryIndex, setPartialContentChanges])

    const handleRedoContentChanges = useCallback(() => {
        if (contentChangesHistoryIndex >= contentChangesHistory.length - 1) {
            return
        }
        const nextIndex = contentChangesHistoryIndex + 1
        setContentChangesHistoryIndex(nextIndex)
        setPartialContentChanges(clonePartialContentChanges(contentChangesHistory[nextIndex] || []))
    }, [clonePartialContentChanges, contentChangesHistory, contentChangesHistoryIndex, setPartialContentChanges])


    const renderOptions = useCallback((document, template, initialPreview, resolvedContentChanges) => {
        const agencyFontConfig = () => {
            if (!isFeatureEnabled(FEATURE.DOCUMENT_CUSTOMIZATION, integration)) {
                return {}
            }
            if (!agency) {
                return {}
            }
            const font_config = {
                heading_2: {
                    color: agency.cover_color,
                    borderColor: agency.cover_color,
                },
                heading_3: {
                    color: "#ffffff",
                    backgroundColor: agency.cover_color,
                },
                footer_title: {
                    color: agency.cover_color,
                },
                cover_title: {
                    color: agency.cover_color,
                }
            }
            return font_config
        }


        const agencyConfig = () => {
            if (!agency) {
                return {}
            }
            const config = {
                cover_color: agency.cover_color,
            }
            return config
        }

        const agencyImages = () => {
            if (!agency) {
                return {}
            }
            const images = {
                logo: agency.logo,
                cover: agency.cover,
            }
        }

        const shouldApplyContentChanges = (document) => {
            if (isContentEditable === null) {
                return document?.content_editable
            }
            return isContentEditable
        }

        const templateForChanges = template ? expandTemplateWithClauses(template, clauses) : templateWithClauses
        const computedContentChanges =
            resolvedContentChanges ?? (
                (initialPreview ? document.content_editable : shouldApplyContentChanges(document))
                    ? buildContentChanges(partialContentChanges, templateForChanges || template || {}, [])
                    : []
            )

        const options = {
            font_config: {
                font_size: previewSettings?.size || document?.font_size || 'normal',
                ...agencyFontConfig(),
            },
            use_watermark: previewSettings?.watermark ?? document?.use_watermark ?? false,
            ...agencyConfig(),
            contentChanges: computedContentChanges
        }
        return options
    }, [previewSettings, partialContentChanges, agency, isContentEditable, partner, user, clauses, templateWithClauses])

    // On document preview
    const handleDocumentPreview = useCallback(

        async (doc, values, template, initialPreview) => {

            if(previewLoadingRef.current) {
                return
            }
            // setShowSidePanel(true)
            setPreviewLoading(true)
            previewLoadingRef.current = true
            setActiveTab('preview')
            let d = singleDoc
            if (doc) d = doc
            let dValues = documentValues
            if (values) dValues = values
            let t = templateObject
            if (template) t = template
            const templateForChanges = expandTemplateWithClauses(t, clauses)
            const resolvedPartialContentChanges =
                initialPreview
                    ? deconstructContentChanges((d?.content_changes || []), templateForChanges || t || {})
                    : partialContentChanges
            const resolvedContentChanges =
                !(initialPreview ? d?.content_editable : isContentEditable)
                    ? []
                    : buildContentChanges(resolvedPartialContentChanges, templateForChanges || t || {}, [])
            const data = await getPreviewData(
                { 
                    ...d, 
                    values: dValues,
                    name: initialPreview ? doc.name : singleDocName,
                    checkboxValues: documentCheckboxValues,
                    custom_cover: initialPreview ? 
                        (doc.custom_cover ?? agency?.cover_page_default)
                        : useCustomCover,
                    empty_lines_added: initialPreview ? doc.empty_lines_added : linesAdded,
                    content_changes: resolvedContentChanges
                },
                t,
                partner === 'jurisur' &&
                config.environment === 'development',
                renderOptions(d, t, initialPreview, resolvedContentChanges)
            )
            if (!data) {
                setPreviewLoading(false)
                previewLoadingRef.current = false
                setPdfPreviewData(null)
                return
            }
            setPdfPreviewData(data)
            setLastPreviewSnapshot(buildPreviewSnapshot({
                values: dValues,
                checkboxValues: documentCheckboxValues,
                useCustomCoverValue: initialPreview ? (d.custom_cover ?? agency?.cover_page_default) : useCustomCover,
                linesAddedValue: initialPreview ? d.empty_lines_added : linesAdded,
                previewSettingsValue: initialPreview ? {
                    watermark: d.use_watermark || false,
                    size: d.font_size || 'normal',
                } : previewSettings,
                isContentEditableValue: initialPreview ? d.content_editable : isContentEditable,
                partialContentChangesValue: partialContentChanges,
            }))
            setPreviewLoading(false)
            previewLoadingRef.current = false
            // eslint-disable-next-line
        },
        [documentValues, singleDoc, templateObject, useCustomCover, documentCheckboxValues, partner, getPreviewData, renderOptions, singleDocName, linesAdded, isContentEditable, agency, buildPreviewSnapshot, partialContentChanges, previewSettings, clauses]
    )

    const documentDownloadHandler = useCallback((extension = 'pdf') => {
        handleDocumentDownload({
            extension,
            document: singleDoc,
            documentValues,
            documentName: singleDocName,
            useCustomCover,
            linesAdded,
            renderOptions,
            templateObjectWithUniqueVarIndexes,
            isContentEditable,
            partialContentChanges,
            templateObject: templateWithClauses || templateObject
        })
    }, [documentValues, handleDocumentDownload, isContentEditable, linesAdded, partialContentChanges, renderOptions, singleDoc, singleDocName, templateObject, templateObjectWithUniqueVarIndexes, useCustomCover, templateWithClauses])

    const handleFetchDocumentHistory = async (doc) => {

        const fetchHistory = async (id, doc) => {
            try {
                const res = await fetch_document_history(id)
                const arr = getDocumentHistory(res)
                setSingleDocHistory(arr)
                if (arr[0]) {
                    setCurrentDocVersionTime({
                        time: arr[0].versions[arr[0].versions.length - 1]
                            .created,
                    })
                } else {
                    setCurrentDocVersionTime({ time: doc.meta.created })
                }
            } catch (err) {
                console.log(err)
            }
        }

        const fetchEvents = async (id) => {
            try {
                const res = await fetch_document_events(id)
                const arr = getDocumentEventsDayArray(res)
                setSingleDocEvents(arr)
            } catch (err) {
                setSingleDocEvents([])
                console.log(err)
            }
        }

        await fetchHistory(params.id, doc)
        await fetchEvents(params.id)
    }

    // Set document based on id
    useEffect(() => {
        // Prefill values with admin data
        

        // Setup document
        const setupDocument = async (templatePage = false) => {
            setIsTemplatePage(templatePage)
            console.log('setup doc****************')
            setDocumentGettingReady(true)
            let doc
            let template
            if (templatePage) {
                template = templates?.[params.id]
                doc = {
                    template: params.id,
                    name: template.name,
                }
            } else {
                doc = documents[params.id]
                if(!doc) return
                template = templates?.[doc.template]
            }
            setSingleDoc(doc)
            setDocument(doc)
            setDocumentId(params.id)
            setDocumentIdState(params.id)
            if (
                !template?.sections &&
                !templateFetching
            ) {
                setTemplateFetching(true)
                template = await getSingleTemplate(doc.template, true)
                setTemplateFetching(false)
            }
            if (!template) {
                setTemplateNotFound(true)
                setSingleDocReady(true)
                return
            }
            setTemplateObject(template)

            const queryStringVariables = qs.parse(history.location.search, {
                ignoreQueryPrefix: true,
            })
            const prefillValues = {}
            prefillValuesWithAdminData(prefillValues, user, signInResult)
            let existingDocumentValuesWithPrefillData = joinValues(
                doc.values || {},
                prefillValues
            )
            extractCustomerData(existingDocumentValuesWithPrefillData)
            setDocumentValues(existingDocumentValuesWithPrefillData)
            setInitialDocumentState(existingDocumentValuesWithPrefillData)
            setDocumentCheckboxValues(doc.checkboxValues || {})
            setSingleDocName(doc.name)
            setSingleDocStatus(doc.status)
            setSingleDocAssignedTo(doc.assigned_to || doc.author || null)
            setDocumentAttachments(doc.attachments || [])
            setInitialDocAttachments(doc.attachments || [])

            setIsContentEditable(doc.content_editable || false)
            
            // Deconstruct saved content changes into partial content changes
            // This allows multiple edits within the same section
            const templateForContentChanges = expandTemplateWithClauses(template, clauses)
            const deconstructedPartialChanges = deconstructContentChanges(doc.content_changes || [], templateForContentChanges)
            setPartialContentChanges(deconstructedPartialChanges)
            resetContentChangesHistory(deconstructedPartialChanges)

            // Don't apply content changes to template here anymore
            // They will be applied dynamically through the useEffect that watches isContentEditable and partialContentChanges
            const templateWithClauses = expandTemplateWithClauses(template, clauses)
            const copyOfTemplate = convertToTemplateObjWithUniqueVarIndexes({ ...templateWithClauses })
            setTemplateObjectWithUniqueVarIndexes(copyOfTemplate)
            setUseCustomCover(doc.custom_cover ?? agency?.cover_page_default ?? true)
            // DEFAULT { size: 'normal', watermark: false }
            setPreviewSettings({
                watermark: doc.use_watermark || false,
                size: doc.font_size || 'normal',
            })
            setLinesAdded(doc.empty_lines_added || false)
            setShareAttachments(doc.share_attachments || [])
            if (clausesLoaded) {
                handleDocumentPreview(
                    doc,
                    existingDocumentValuesWithPrefillData,
                    template,
                    true
                )
            }
            getCustomersFromData(
                existingDocumentValuesWithPrefillData,
                setDocumentContacts
            )
            setDocSignatureRecipients(doc.signatureRecipients || [])
            setSingleDocReady(true)
            handleFetchDocumentHistory(doc)

            setTimeout(() => {
                // trigger actions based on query params, wait for other setups to finish
                if(queryStringVariables.validation !== undefined && isFeatureEnabled(FEATURE.DOCUMENT_VALIDATION, integration)) {
                    enableValidationMode()
                }
                if(queryStringVariables.share !== undefined) {
                    handleOpenShareModal(false, false, false, doc, template)
                }
                if(queryStringVariables.sign !== undefined) {
                    handleOpenSignModal(doc, template)
                }
            }, 500)

        }

        let components = history.location.pathname.split('/')
        const documentPaths = [
            'documents',
            'document-detail',
            'v2-documents',
            'document-revision'
        ]
        const templatePaths = ['templates', 'template', 'v2-templates']
        let location = components[1]
        if (params.id && documentsLoaded && validationsFetched && (templatesLoaded || location === 'document-revision')) {
            if (documentPaths.includes(location)) {
                if (documents[params.id]) {
                    if (
                        (!singleDocReady && !documentGettingReady) ||
                        params.id !== documentId
                    ) {
                        setupDocument()
                    }
                    setSingleDocNotFound(false)
                } else {
                    setSingleDocArchived(Boolean(archivedDocuments[params.id]))
                    setSingleDocDeleted(Boolean(deletedDocuments[params.id]))
                    setSingleDocNotFound(true)
                    setSingleDocReady(true)
                }
            } else if (templatePaths.includes(location)) {
                if (templates[params.id]) {
                    if (!singleDocReady && !documentGettingReady) {
                        setupDocument(true)
                    }
                    setSingleDocNotFound(false)
                } else {
                    setTemplateNotFound(true)
                    // setSingleDocNotFound(true)
                    setSingleDocReady(true)
                }
            } else {
                // invalid paths
            }
        }
    }, [
        location,
        documentId,
        params.id,
        documents,
        templates,
        documentsLoaded,
        templatesLoaded,
        singleDocReady,
        getSingleTemplate,
        templateFetching,
        documentGettingReady,
        history.location.search,
        history.location.pathname,
        joinValues,
        handleDocumentPreview,
        partner,
        getCustomersFromData,
        extractCustomerData,
        signInResult,
        user,
        partialContentChanges,
        archivedDocuments,
        deletedDocuments,
        clauses,
        resetContentChangesHistory
    ])

    useEffect(() => {
        if (!clausesLoaded || !singleDoc || !Array.isArray(singleDoc.content_changes) || singleDoc.content_changes.length === 0) {
            return
        }
        if (!templateObject) {
            return
        }
        const templateForContentChanges = expandTemplateWithClauses(templateObject, clauses)
        if (!templateForContentChanges?.sections) {
            return
        }
        const reconstructedChanges = deconstructContentChanges(singleDoc.content_changes || [], templateForContentChanges)
        if (!Array.isArray(reconstructedChanges) || reconstructedChanges.length === 0) {
            return
        }
        setPartialContentChanges((prevChanges) => {
            const previous = Array.isArray(prevChanges) ? prevChanges : []
            const mergedMap = new Map()
            reconstructedChanges.forEach((change) => {
                mergedMap.set(partialContentChangeKey(change), change)
            })
            previous.forEach((change) => {
                mergedMap.set(partialContentChangeKey(change), change)
            })
            const mergedChanges = Array.from(mergedMap.values())
            if (mergedChanges.length === previous.length) {
                let same = true
                const previousMap = new Map(previous.map((change) => [partialContentChangeKey(change), change]))
                for (const change of mergedChanges) {
                    const prev = previousMap.get(partialContentChangeKey(change))
                    if (!prev || (prev.newContent ?? prev.editedContent ?? '') !== (change.newContent ?? change.editedContent ?? '') || (prev.originalContent || '') !== (change.originalContent || '')) {
                        same = false
                        break
                    }
                }
                if (same) {
                    return previous
                }
            }
            return mergedChanges
        })
    }, [clausesLoaded, singleDoc, templateObject, clauses, setPartialContentChanges, partialContentChangeKey])

    const handleOpenValidationModal = async (save = true) => {

        
        if(save) {
            setGlobalResponseLoaderText('Enregistrement du document')
            setShowGlobalResponseLoader(true)
            await handleSave()
            setGlobalResponseLoaderText('')
            setShowGlobalResponseLoader(false)
        }
        openValidationModal()

    }

    // On open share modal
    const handleOpenShareModal = async (save = true, ignoreCompletion = false, ignoreValidation = false, document = null, template = null) => {
        const validation = activeValidationRef.current
        if(!isFeatureEnabled(FEATURE.DOCUMENT_VALIDATION, integration)) {
            ignoreValidation = true
        }

        const singleDocForShare = document || singleDoc
        const templateForShare = template || templateObject

        const isComplete = progress >= 1 || singleDocForShare.empty_lines_added
        const isValidated = validation?.status === VALIDATION_STATUS.VALIDATED
        const isValidationRequired = isTemplateValidationRequired(templateForShare.id)

        // console.log('handleOpenShareModal', {ignoreCompletion, ignoreValidation, isComplete, isValidated, isValidationRequired})

        if(!(ignoreCompletion && ignoreValidation) && (!isComplete || !isValidated)) {
            const status = []
            if(!isComplete) {
                status.push(VALIDATION_STATUS.NOT_COMPLETE)
            }
            if(!isValidated) {
                status.push(VALIDATION_STATUS.NOT_VALIDATED)
            } else {
                status.push(VALIDATION_STATUS.VALIDATED)
            }
            if(isValidationRequired) {
                status.push(VALIDATION_STATUS.VALIDATION_REQUIRED)
            }

            showValidationWarning({
                document: singleDocForShare,
                action: 'share',
                status: status,
                validation,
                isValidator: user.validation_access === 'manager',
                onConfirm: () => {
                    handleOpenShareModal(save, true, true, singleDocForShare, templateForShare)
                    closeValidationWarning()
                },
                onCancel: () => {
                    if(!isValidated) {
                        if(!activeValidationRef.current) {
                            openValidationModal()
                        } else {
                            enableValidationMode()
                        }
                    }
                    closeValidationWarning()
                }
            })
            return
        }
        
        if(save) {
            setGlobalResponseLoaderText('Enregistrement du document')
            setShowGlobalResponseLoader(true)
            await handleSave()
            setGlobalResponseLoaderText('')
            setShowGlobalResponseLoader(false)
        }
        setShowShareModal(true)
    }

    // On close share modal
    const handleCloseShareModal = () => {
        setShowShareModal(false)
    }


    // On open sign modal
    const handleOpenSignModal = async (doc, template) => {
        const validation = activeValidationRef.current
        if(!template) {
            template = templateObject
        }
        if(!doc) {
            doc = {
                ...singleDoc,
                progress: progress,
            }
        }
        const signatureMode = SIGNATURE_MODE_FOR_TEMPLATE[config.environment]?.[template?.id] || template?.signature_mode || 'none'
        const validSignatureModes = ['automatic', 'manual']
        const signaturesAvailable =  validSignatureModes.includes(signatureMode)

        if(!signaturesAvailable) {
            showValidationWarning({
                document: doc,
                action: 'sign',
                status: [VALIDATION_STATUS.SIGNATURE_NOT_AVAILABLE],
                validation,
                onConfirm: () => {},
                onCancel: () => {
                    closeValidationWarning()
                    setShowSignModal(false)
                }
            })
            return
        }
        const isDocumentValidationRequired = isTemplateValidationRequired(singleDoc.template)

        const isUserValidator = user.validation_access === 'manager'
        const isDocumentComplete = progress >= 1 || singleDoc.empty_lines_added
        const isDocumentValidated = activeValidation?.status === VALIDATION_STATUS.VALIDATED
        let shouldShowValidationWarning = false
        const status = []

        if(!isDocumentComplete) {
            shouldShowValidationWarning = true
            status.push(VALIDATION_STATUS.NOT_COMPLETE)
        }
        if(!isUserValidator && isDocumentValidationRequired && !isDocumentValidated) {
            shouldShowValidationWarning = true
        }
        if(!isUserValidator && !isDocumentValidationRequired && !isDocumentValidated && activeValidation) {
            shouldShowValidationWarning = true
        }
        if(isUserValidator && !isDocumentValidated && activeValidation) {
            shouldShowValidationWarning = true
        }

        if(!isFeatureEnabled(FEATURE.DOCUMENT_VALIDATION, integration)) {
            shouldShowValidationWarning = false
        }

        if(!isDocumentValidated) {
            status.push(VALIDATION_STATUS.NOT_VALIDATED)
        } else {
            status.push(VALIDATION_STATUS.VALIDATED)
        }
        if(isDocumentValidationRequired) {
            status.push(VALIDATION_STATUS.VALIDATION_REQUIRED)
        }

        if(shouldShowValidationWarning) {
            showValidationWarning({
                document: doc,
                action: 'sign',
                status: status,
                validation,
                onConfirm: async () => {
                    closeValidationWarning()
                    if(isUserValidator || !isDocumentValidationRequired || isDocumentValidated) {
                        const saveSucceeded = await handleSave()
                        if(saveSucceeded) {
                            setShowSignModal(true)
                        }
                        return
                    }
                    if(!activeValidation) {
                        // open validation modal if no validation exists
                        openValidationModal()
                    } else {
                        // switch to validation mode if validation exists
                        enableValidationMode()
                    }
                },
                onCancel: () => {
                    setShowSignModal(false)
                    closeValidationWarning()
                }
            })
            return            
        }

        const saveSucceeded = await handleSave()
        if(saveSucceeded) {
            setShowSignModal(true)
        }
    }



    const handleSendLRE = (template) => {
        if(!template) {
            template = templateObject
        }

        const isDocumentValidationRequired = isTemplateValidationRequired(singleDoc.template)

        const isUserValidator = user.validation_access === 'manager'
        const isDocumentComplete = progress >= 1 || singleDoc.empty_lines_added
        const isDocumentValidated = activeValidation?.status === VALIDATION_STATUS.VALIDATED
        let shouldShowValidationWarning = false

        if(!isDocumentComplete) {
            shouldShowValidationWarning = true
        }
        if(!isUserValidator && isDocumentValidationRequired && !isDocumentValidated) {
            shouldShowValidationWarning = true
        }
        if(!isUserValidator && !isDocumentValidationRequired && !isDocumentValidated && activeValidation) {
            shouldShowValidationWarning = true
        }
        if(isUserValidator && !isDocumentValidated && activeValidation) {
            shouldShowValidationWarning = true
        }

        if(!isFeatureEnabled(FEATURE.DOCUMENT_VALIDATION, integration)) {
            shouldShowValidationWarning = false
        }

        if(shouldShowValidationWarning) {
            const status = []
            if(!isDocumentComplete) {
                status.push(VALIDATION_STATUS.NOT_COMPLETE)
            }
            if(!isDocumentValidated) {
                status.push(VALIDATION_STATUS.NOT_VALIDATED)
            } else {
                status.push(VALIDATION_STATUS.VALIDATED)
            }
            if(isDocumentValidationRequired) {
                status.push(VALIDATION_STATUS.VALIDATION_REQUIRED)
            }
            showValidationWarning({
                document: singleDoc,
                action: 'lre',
                status: status,
                validation: activeValidation,
                onConfirm: () => {
                    closeValidationWarning()
                    if(isUserValidator || !isDocumentValidationRequired || isDocumentValidated) {
                        // continue to create LRE request
                        createAr24MailRequestFromDocument({ document: singleDoc, documentValues, documentCheckboxValues, documentName: singleDocName, documentContacts: activeDocumentContacts })
                        return
                    }
                    if(!activeValidation) {
                        // open validation modal if no validation exists
                        openValidationModal()
                    } else {
                        // switch to validation mode if validation exists
                        enableValidationMode()
                    }
                }
            })
            return
        } 
        
        createAr24MailRequestFromDocument({ document: singleDoc, documentValues, documentCheckboxValues, documentName: singleDocName, documentContacts: activeDocumentContacts })
    }

    // On close sign modal
    const handleCloseSignModal = () => {
        setShowSignModal(false)
    }

    // Cleanup
    useEffect(() => {
        return () => {
            if (scrollToItemTimeout) {
                clearTimeout(scrollToItemTimeout)
            }
        }
    }, [])

    useEffect(() => {
        if(!isFeatureEnabled(FEATURE.AUTOMATIC_DOCUMENT_STATUS, integration)) return
        const newStatus = documents[documentId]?.status
        if(newStatus !== 'ready' && newStatus !== 'draft') {
            setSingleDocStatus(newStatus)
        } else {
            // set status based on progress
            if(progress === 1 || linesAdded) {
                setSingleDocStatus('ready')
            } else {
                setSingleDocStatus('draft')
            }
        }
    }, [progress, linesAdded, singleDocStatus, documents, documentId, integration])

    useEffect(() => {
        // update values when document is updated (after suggestion accept for ex.)
        let template
        const doc = documents[documentId]
        if(!doc) return
        if(!templates) return
        template = templates[doc.template]
        if(!template) {
            return
        }

        const prefillValues = {}
        prefillValuesWithAdminData(prefillValues, user, signInResult)
        let existingDocumentValuesWithPrefillData = joinValues(
            {
                ...(singleDocReady ? documentValues : {}),
                ...doc.values,
            },
            prefillValues
        )
        setDocumentValues(existingDocumentValuesWithPrefillData)
    }, [templates, documents, documentId])

    useEffect(() => {
        // update document attachments when document is saved
        setDocumentAttachments(documents[params.id]?.attachments || [])
    }, [params.id, documents, setDocumentAttachments])

    // prevent user from changing route when have unsaved data
    const [isBlocking, setIsBlocking] = useState(false);
    const [initialDocumentState, setInitialDocumentState] = useState();
    const [initialDocAttachments, setInitialDocAttachments] = useState();

    useEffect(() => {
        let block = false
        if (documentValues) {
            if (!areObjectsEqual(initialDocumentState, documentValues)) {
                block = true
            }
        }
        if(documentAttachments) {
            if(!areObjectsEqual(initialDocAttachments, documentAttachments)) {
                block = true
            }
        }
        setIsBlocking(block)
    }, [documentValues, initialDocumentState, documentAttachments, initialDocAttachments]);

    useEffect(() => {
        if(!templateObject) {
            return
        }
        if(!clausesLoaded) {
            return
        }
        if(!singleDoc) {
            return
        }
        if(pdfPreviewData) {
            return
        }
        // re-render document preview when clauses are loaded
        handleDocumentPreview(singleDoc, documentValues, templateObject, true)
    }, [singleDoc, clausesLoaded, documentValues, templateObject, pdfPreviewData])

    // Reset setup
    const resetSetup = () => {
        setSingleDocReady(false)
        setDocumentGettingReady(false)
    }

    const findEmptyVariableInSection = (section, repetitionIds, repetitionIndices) => {
        if(section.variable) {
            const val = value(section.variable, repetitionIds, repetitionIndices)
            if(!val) {
                return {
                    variable: {...section},
                    repetitionIds: repetitionIds,
                    repetitionIndices: repetitionIndices
                }
            }
        } else if(section.variables) {
            for(let va of section.variables) {
                const val = value(va.variable, repetitionIds, repetitionIndices)
                if(!val) {
                    return {
                        variable: va,
                        repetitionIds: repetitionIds,
                        repetitionIndices: repetitionIndices
                    }
                }
            }
        } else if(section.items) {
            for(let i = 0; i < section.items.length; i++) {
                const item = section.items[i]
                if(item.variable) {
                    const val = value(item.variable, repetitionIds, repetitionIndices)
                    if(!val) {
                        return {
                            variable: {...item},
                            repetitionIds: repetitionIds,
                            repetitionIndices: repetitionIndices
                        }
                    }
                }
                if(item.variables) {
                    for(let va of item.variables) {
                        const val = value(va.variable, repetitionIds, repetitionIndices)
                        if(!val) {
                            return {
                                variable: va,
                                repetitionIds: repetitionIds,
                                repetitionIndices: repetitionIndices
                            }
                        }
                    }
                }
            }
        }
    }

    const findFirstEmptyVariable = () => {
        for(let section of templateObjectWithUniqueVarIndexes.sections) {
            const repIds = section.repeatable_section_ids || section.repeatable_section_id ? [section.repeatable_section_id] : []
            if(repIds.length === 1) {
                const repetitionValuesArray = duplicatableValuesArray([...repIds], [])
                for(let i = 0; i < repetitionValuesArray.length; i++) {
                    const emptyVariable = findEmptyVariableInSection(section, repIds, [i])
                    if(emptyVariable) {
                        return emptyVariable
                    }
                }
            } else if(repIds.length === 2) {
                const outerRepetitionValuesArray = duplicatableValuesArray([repIds[0]], [])
                for(let i = 0; i < outerRepetitionValuesArray.length; i++) {
                    const innerRepetitionValuesArray = duplicatableValuesArray([repIds[0], repIds[1]], [i])
                    for(let j = 0; j < innerRepetitionValuesArray.length; j++) {
                        const emptyVariable = findEmptyVariableInSection(section, repIds, [i, j])
                        if(emptyVariable) {
                            return emptyVariable
                        }
                    }
                }
            } else {
                const emptyVariable = findEmptyVariableInSection(section, [], [])
                if(emptyVariable) {
                    return emptyVariable
                }
            }
        }
    }

    const handleNavigateToEmptyVariable = () => {
        const variableInfo = findFirstEmptyVariable()
        if(!variableInfo) {
            return
        }
        const element = bodyWrapEl.current.querySelector(
            `[data-id="${variableInfo.variable.idx}"]`
        )
        if(!element) {
            return
        }
        const input =
            element.querySelector('input') ||
            element.querySelector('textarea')
        if (input) {
            input.focus()
        }
        setScrollingToItem(true)
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        scrollToItemTimeout = setTimeout(
            () => setScrollingToItem(false),
            1000
        )
    }

    // Handle variable item click
    const handleVariableItemClick = useCallback((id) => {
        const element = bodyWrapEl.current.querySelector(
            `[data-id="${id}"]`
        )
        if (element) {
            const input =
                element.querySelector('input') ||
                element.querySelector('textarea')
            if (input) {
                input.focus()
            }
            setScrollingToItem(true)
            console.log(element.getBoundingClientRect().top)
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            // I managed offset using scroll-margin in CSS
            scrollToItemTimeout = setTimeout(
                () => setScrollingToItem(false),
                1000
            )
        }
    }, [])

    // Handle section click
    const handleSectionClick = useCallback((id) => {
        const element = bodyWrapEl.current.querySelector(
            `[data-id="section-${id}"]`
        )
        if (element) {
            setScrollingToItem(true)
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            // I managed offset using scroll-margin in CSS
            scrollToItemTimeout = setTimeout(
                () => setScrollingToItem(false),
                1000
            )
        }
    }, [])

    // On document values change
    const handleDocumentValuesChange = useCallback(
        (variable, value) => {
            // console.log("handleDocumentValuesChange", variable, value), value)
            if (typeof variable === 'object' && Array.isArray(variable)) {
                let dv = { ...documentValues }
                for (let i in variable) {
                    dv[variable[i]] = value[i]
                    if(value[i] === null) {
                        delete dv[variable[i]]
                    }
                }
                setDocumentValues((values) => ({ ...values, ...dv, }))
            } else {
                if(value === null) {
                    setDocumentValues((values) => {
                        delete values[variable]
                        return { ...values }
                    })
                } else {
                    setDocumentValues((values) => ({ ...values, [variable]: value }))
                }
            }
        },
        [documentValues]
    )

    // On document checkbox values change
    const handleDocumentCheckboxValuesChange = useCallback(
        (id, value) => {
            setDocumentCheckboxValues({
                ...documentCheckboxValues,
                [id]: value,
            })
        },
        [documentCheckboxValues]
    )

    // On side panel toggle
    const handleToggleSidePanel = useCallback((value) => {
        let show = !sidePanelOpenStatus[view]
        if(value !== undefined) {
            show = value
        }
        if (view === 'variables' && show && !pdfPreviewData) {
            handleDocumentPreview(singleDoc, documentValues, templateObject)
        }
        setSidePanelOpenStatus((status) => ({
            ...status,
            [view]: show,
        }))
    }, [sidePanelOpenStatus, view, handleDocumentPreview, singleDoc, documentValues, templateObject, pdfPreviewData])

    // On tab change - only on smaller screens max-width 768px
    const handleTabChange = (e, tab, attachments = false) => {
        e.preventDefault()
        setActiveTab(tab)
        if (tab === 'preview' && !pdfPreviewData) {
            handleDocumentPreview(singleDoc, documentValues, templateObject)
        }
        if (attachments) {
            setView('attachments')
        } else {
            setView('variables')
        }
    }

    const handleNavbarDocumentPreview = useCallback(() => {
        if (!sidePanelOpenStatus.variables) {
            handleToggleSidePanel()
        } else if (!pdfPreviewData) {
            handleDocumentPreview(singleDoc, documentValues, templateObject)
        }
    }, [sidePanelOpenStatus, handleToggleSidePanel, handleDocumentPreview, documentValues, singleDoc, templateObject, pdfPreviewData])

    const handleCreateStandardTemplate = async () => {
        // TODO create standart template
        setShowGlobalResponseLoader(true, 2000)
        setGlobalResponseLoaderText('Ouverture du modèle type créé')
        // history.push(`/documents/create-standard-template/${documentId}`)
        const standardTemplateResponse = await createStandardTemplate({
            document: singleDoc,
            template: templateObject,
            values: documentValues,
            checkboxValues: documentCheckboxValues,
            name: singleDocName,
            customCover: useCustomCover,
            attachments: documentAttachments,
            content_changes: isContentEditable ? buildContentChanges(partialContentChanges, templateWithClauses || templateObject, []) : [],
            content_editable: isContentEditable,
        })
        if (standardTemplateResponse.error) {
            return
        }
        history.push(`/standard-templates/${standardTemplateResponse.id}`)
        setShowGlobalResponseLoader(false)
    }

    // On save
    const handleSave = useCallback(async () => {
        let saveSucceeded = false
        setShowGlobalResponseLoader(true)
        setGlobalResponseLoaderText('Sauvegarde du document');
        if (!isContentEditable) {
            setPartialContentChanges([])
            resetContentChangesHistory([])
        }
        try {
            let docValues = documentValues
            if (isTemplatePage) {
                let data = {
                    values: {},
                    checkboxValues: {},
                    name: templateObject.name,
                    status: 'draft',
                    template: templateObject.id,
                    progress: 0,
                    folderId: [],
                    custom_cover: useCustomCover,
                    content_changes: isContentEditable ? buildContentChanges(partialContentChanges, templateWithClauses || templateObject, [], true, true) : [],
                    content_editable: isContentEditable,
                    use_watermark: previewSettings?.watermark !== undefined ? previewSettings.watermark : false,
                    font_size: previewSettings?.size || 'normal',
                    attachments: documentAttachments || [],
                    empty_lines_added: linesAdded,
                    assigned_to: singleDocAssignedTo ? ({
                        id: `${singleDocAssignedTo.id}`,
                        firstname: singleDocAssignedTo.firstname,
                        lastname: singleDocAssignedTo.lastname,
                        email: singleDocAssignedTo.email,
                    }) : null
                }
                if (docValues) {
                    data.values = docValues
                }
                try {
                    const id = await createDocument(data)
                    setSingleDocName(templateObject.name)
                    resetSetup()
                    history.replace(`/documents/${id}`)
                } catch (err) {
                    setNotification({
                        msg: 'Une erreur est survenue, merci de réessayer',
                        type: 'danger',
                    })
                    return false
                }
            } else {
                let documentUpdates = {
                    values: docValues,
                    checkboxValues: documentCheckboxValues,
                    name: singleDocName,
                    status: singleDocStatus,
                    progress: progress,
                    custom_cover: useCustomCover,
                    use_watermark: previewSettings?.watermark !== undefined ? previewSettings.watermark : singleDoc.use_watermark || false,
                    font_size: previewSettings?.size || singleDoc.font_size || 'normal',
                    attachments: documentAttachments,
                    content_changes: isContentEditable ? buildContentChanges(partialContentChanges, templateWithClauses || templateObject, [], true, true) : [],
                    content_editable: isContentEditable,
                    empty_lines_added: linesAdded,
                    assigned_to: singleDocAssignedTo ? ({
                        id: `${singleDocAssignedTo.id}`,
                        firstname: singleDocAssignedTo.firstname,
                        lastname: singleDocAssignedTo.lastname,
                        email: singleDocAssignedTo.email,
                    }) : null                    
                }
                await updateDocument(documentUpdates, {
                    ...singleDoc,
                    id: documentId,
                    attachments: documentAttachments,
                })
                setSingleDoc((doc) => ({
                    ...doc,
                    ...documentUpdates,
                }))
                setDocument((doc) => ({
                    ...doc,
                    ...documentUpdates,
                }))
                setCurrentDocVersionTime({ time: Date.now() })
            }
            setDocumentValues(docValues)
            setInitialDocumentState(docValues)
            setInitialDocAttachments([...(documentAttachments || [])])
            saveSucceeded = true
        } catch (err) {
            console.error("handleSave", err)
            setNotification({
                msg: 'Une erreur est survenue, merci de réessayer',
                type: 'danger',
            })
        } finally {
            setShowGlobalResponseLoader(false)
            setGlobalResponseLoaderText('')
        }
        return saveSucceeded
        // eslint-disable-next-line
    }, [
        documentCheckboxValues,
        documentId,
        documentValues,
        singleDocName,
        singleDocStatus,
        templateObject,
        singleDoc,
        useCustomCover,
        documentAttachments,
        isContentEditable,
        partialContentChanges,
        previewSettings,
        progress,
        linesAdded,
        singleDocAssignedTo,
    ])

    // On name change
    const handleNameChange = useCallback((e) => {
        const name = (e.currentTarget.textContent || '').replace(/\s+/g, ' ').trim()
        setSingleDocName(name)
    }, [])

    // On attachment share save
    const handleAttachmentShareSave = async (shareAttachments) => {
        if (documentId) {
            setShowGlobalResponseLoader(true)
            await updateDocument(
                {
                    share_attachments: shareAttachments,
                },
                {
                    ...singleDoc,
                    id: documentId,
                    share_attachments: shareAttachments,
                }
            )
            setShowGlobalResponseLoader(false)

        }
        setShareAttachments(shareAttachments)
    }

    // On version restore
    const handleVersionRestore = (version) => {
        setDocumentValues(version.values)
        setInitialDocumentState(version.values)
        setSingleDocName(version.name)
        setCurrentDocVersionTime({ time: version.created })
    }

    // On agency modal open
    const handleOpenAgencyModal = () => {
        setShowAgencyModal(true)
    }

    // On agency modal close
    const handleCloseAgencyModal = () => {
        setShowAgencyModal(false)
    }

    // On notaries modal open
    const handleOpenNotariesModal = () => {
        setShowNotariesModal(true)
    }

    // On close notaries modal
    const handleCloseNotariesModal = () => {
        setShowNotariesModal(false)
    }

    // On open add/edit notary modal
    const handleOpenAddEditNotaryModal = () => {
        setShowAddEditNotaryModal(true)
    }

    // On close add/edit notary modal
    const handleCloseAddEditNotaryModal = () => {
        setShowAddEditNotaryModal(false)
    }

    const onPreviewSettingsChange = (settings) => {
        setPreviewSettings(settings)
    }

    const handleToggleMoreActions = () => {
        setShowMoreActions(!showMoreActions)
    }

    const handleScroll = () => {
        const element = document.getElementById('direction1')
        const { scrollTop } = element

        if (arrayStack[arrayStack.length - 1] < scrollTop) {
            arrayStack.push(scrollTop)
            setIsScroll(true)
        } else {
            arrayStack.length = 0
            arrayStack.push(scrollTop)
            setIsScroll(false)
        }
    }

    const handleRenderSettingsSave = (settings) => {
        setUseCustomCover(settings.useCustomCover ?? singleDoc.custom_cover ?? agency.cover_page_default ?? true)
        setPreviewSettings({
            size: settings.size || 'normal',
            watermark: settings.watermark || false
        })
        setLinesAdded(settings.linesAdded || false)
    }


    if (templateNotFound) {
        return (
            <Layout
                className="page-document"
                pageTitle="Mes documents"
                titleIcon={<FileAlt2 />}
            >
                <ResourceNotFound
                    title="Modèle non trouvé"
                    text="Le modèle de ce document est introuvable"
                />
            </Layout>
        )
    }

    if (!singleDocReady && !authError) {
        return (
            <Layout
                className="page-document"
                pageTitle="Mes documents"
                titleIcon={<FileAlt2 />}
            >
                <ResponseLoader
                    text="Document en cours de création"
                    className="response-loader-v2--dark"
                />
            </Layout>
        )
    }

    if(singleDocDeleted) {
        return (
            <Layout
                className="page-document"
                pageTitle="Mes documents"
                titleIcon={<FileAlt2 />}
            >
                <ResourceNotFound
                    title="Document à supprimer"
                    text={"Pour visualiser le document, veuillez le sélectionner puis cliquer sur \"Restaurer\". Il sera alors de nouveau visible dans vos documents actifs."}
                />
            </Layout>
        )
    }

    if(singleDocArchived) {
        return (
            <Layout
                className="page-document"
                pageTitle="Mes documents"
                titleIcon={<FileAlt2 />}
            >
                <ResourceNotFound
                    title="Document archivé"
                    text={"Pour visualiser le document, veuillez le sélectionner puis cliquer sur \"Restaurer\". Il sera alors de nouveau visible dans vos documents actifs."}
                />
            </Layout>
        )
    }

    if (singleDocNotFound) {
        return (
            <Layout
                className="page-document"
                pageTitle="Mes documents"
                titleIcon={<FileAlt2 />}
            >
                <ResourceNotFound
                    title="Document non trouvé"
                    text={`Le document avec l'id "${params.id}" est introuvable`}
                />
            </Layout>
        )
    }

    if(!singleDocReady) {
        return (
            <Layout
                className="page-document"
                pageTitle="Mes documents"
                titleIcon={<FileAlt2 />}
            >
            </Layout>
        )
    }

    return (
        <Layout
            className="page-document"
            pageTitle={revisionModeEnabled ? 'Mode révision' : "Rédaction d'un document"}
            hideTitleOnDesktop={true}
            showSearch={true}
            searchIn="documentItem"
            titleLeftElement={revisionModeEnabled ? <button className="btn btn--primary-light btn--circle" onClick={disableValidationMode}><ArrowBack /></button> : null}
        >
            <Prompt
                when={isBlocking}
                message={() =>
                    `Les modifications que vous avez apportées ne seront pas enregistrées. Souhaitez-vous quitter cette page?`
                }
            />
            <div
                className=""
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <div className="single-document-mobile-title">
                    <h1
                        style={{ width: '80%' }}
                        contentEditable
                        suppressContentEditableWarning={true}
                        onInput={handleNameChange}
                    >
                        {singleDoc?.name}
                    </h1>
                    {/* <div style={{ position: 'relative' }}>
                        {showMoreActions && (
                            <div
                                className="more-dropdown"
                                style={{
                                    position: 'absolute',
                                    right: 10,
                                    top: 15,
                                    width: '200px',
                                    padding: '5px',
                                }}
                            >
                                <ul>
                                    <li
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}
                                        onClick={() => {
                                            setHideActionBar(
                                                (prev) => !prev
                                            )
                                            setTimeout(() => {
                                                handleToggleMoreActions()
                                            }, 150)
                                        }}
                                    >
                                        {hideActionBar ? (
                                            <VisibilityIcon />
                                        ) : (
                                            <VisibilityOffIcon />
                                        )}
                                        <span
                                            className="text"
                                            style={{ marginLeft: '6px' }}
                                        >
                                            hide/show action panel
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        )}
                    </div> */}
                </div>
            </div>
            <div
                className={`single-document ${sidePanelOpenStatus[view] ? 'opened' : ''
                    } ${layout === 'public' ? 'single-document--public' : ''}`}
            >
                {layout !== 'public' && <SingleDocumentSidebar
                    singleDoc={singleDoc}
                    currentDocVersionTime={currentDocVersionTime}
                    documentValues={documentValues}
                    onVariableItemClick={handleVariableItemClick}
                    scrollingToItem={scrollingToItem}
                    onSectionClick={handleSectionClick}
                    templateData={templateObjectWithUniqueVarIndexes}
                    tabActive={activeTab === 'summary'}
                    onNameChange={handleNameChange}
                    singleDocName={singleDocName}
                    view={view}
                    onSetView={view => {
                        setView(view)
                    }}
                    numOfAttachments={[...filteredDocumentAttachments, ...filteredDefaultAttachments].length}
                    attachments={[...filteredDocumentAttachments, ...filteredDefaultAttachments]}
                    status={singleDocStatus}
                    progress={progress}
                    templateMetaSections={templateMetaSections}
                    summarySections={summarySections}
                    assignedTo={singleDocAssignedTo}
                    onSetAssignedTo={setSingleDocAssignedTo}
                    onSetStatus={setSingleDocStatus}
                    onStartValidation={handleOpenValidationModal}
                /> }
                {layout === 'public' && <PublicDocumentSidebar
                    singleDoc={singleDoc}
                    currentDocVersionTime={currentDocVersionTime}
                    documentValues={documentValues}
                    onVariableItemClick={handleVariableItemClick}
                    scrollingToItem={scrollingToItem}
                    onSectionClick={handleSectionClick}
                    templateData={templateObjectWithUniqueVarIndexes}
                    tabActive={activeTab === 'summary'}
                    onNameChange={handleNameChange}
                    singleDocName={singleDocName}
                    view={view}
                    onSetView={view => {
                        setView(view)
                    }}
                    numOfAttachments={[...filteredDocumentAttachments, ...filteredDefaultAttachments].length}
                    attachments={[...filteredDocumentAttachments, ...filteredDefaultAttachments]}
                    status={singleDocStatus}
                    progress={progress}
                    templateMetaSections={templateMetaSections}
                    summarySections={summarySections}
                    assignedTo={singleDocAssignedTo}
                    onSetAssignedTo={setSingleDocAssignedTo}
                /> }
                <div
                    className={`single-document__main document-main single-document-tab ${activeTab === 'main' ? 'tab-active' : ''
                        } show-scrollbar`}
                    id="direction1"
                    ref={bodyWrapEl}
                    onScroll={() => handleScroll()}
                >
                    <SingleDocumentMain
                        singleDoc={{
                            ...singleDoc,
                            id: documentId,
                            name: singleDocName,
                            status: singleDocStatus,
                            attachments: documentAttachments,
                            values: documentValues,
                            checkboxValues: documentCheckboxValues,
                        }}
                        templateData={templateObjectWithUniqueVarIndexes}
                        documentValues={documentValues}
                        onValuesChange={handleDocumentValuesChange}
                        documentCheckboxValues={documentCheckboxValues}
                        onCheckboxValueChange={
                            handleDocumentCheckboxValuesChange
                        }
                        useCustomCover={useCustomCover}
                        onAgencyModalOpen={handleOpenAgencyModal}
                        onNotariesModalOpen={handleOpenNotariesModal}
                        onSave={handleSave}
                        onDocumentPreview={handleNavbarDocumentPreview}
                        linesAdded={linesAdded}
                        attachments={documentAttachments}
                        // onAttachmentShareUpdate={
                        //     handleAttachmentShareUpdate
                        // }
                        onAttachmentShareSave={handleAttachmentShareSave}
                        documentId={documentId}
                        documentName={singleDocName}
                        template={templateObject}
                        docContacts={documentContacts}
                        activeDocContacts={activeDocumentContacts}
                        docSignatureRecipients={docSignatureRecipients}
                        onSetDocumentValues={setDocumentValues}
                        onFetchHistory={handleFetchDocumentHistory}
                        docHistory={singleDocHistory}
                        docEvents={singleDocEvents}
                        onVersionRestore={handleVersionRestore}
                        onResetSetup={resetSetup}
                        view={view}
                        onSetView={setView}
                        onSetDocumentAttachments={setDocumentAttachments}
                        onSetTab={handleTabChange}
                        onToggleSidePanel={handleToggleSidePanel}
                        isSidePanelOpen={sidePanelOpenStatus[view]}
                        isContentEditable={isContentEditable}
                        onToggleContentEditable={handleToggleContentEditable}
                        onSectionContentChanged={onSectionContentChanged}
                        onUndoContentChanges={handleUndoContentChanges}
                        onRedoContentChanges={handleRedoContentChanges}
                        canUndoContentChanges={contentChangesHistoryIndex > 0}
                        canRedoContentChanges={contentChangesHistoryIndex < contentChangesHistory.length - 1}
                        onDocumentDownload={documentDownloadHandler}
                        previewSettings={previewSettings}
                        templateMetaSections={templateMetaSections}
                        onPreviewRefresh={() => handleDocumentPreview(singleDoc, documentValues, templateObject)}
                        onRenderSettingsSave={handleRenderSettingsSave}
                        progress={progress}
                        onCreateStandardTemplate={handleCreateStandardTemplate}
                        onNavigateToEmptyVariable={handleNavigateToEmptyVariable}
                        renderOptions={renderOptions(singleDoc, templateObject)}
                        shareAttachments={shareAttachments}
                        onShare={handleOpenShareModal}
                        onSign={() => handleOpenSignModal()}
                        onLRE={handleSendLRE}
                        layout={layout}
                    />
                </div>
                <SingleDocumentSidePanel
                    hidePreviewInMobile={(e) => handleTabChange(e, 'summary')}
                    onToggle={() => {
                        setPrefilledAttachmentVariable(null)
                        handleToggleSidePanel()
                    }}
                    previewData={pdfPreviewData}
                    previewLoading={previewLoading}
                    onPreviewRefresh={() => handleDocumentPreview(singleDoc, documentValues, templateObject)}
                    tabActive={activeTab === 'preview'}
                    view={view}
                    isPreviewUpToDate={isPreviewUpToDate}
                    onSetDocumentAttachments={setDocumentAttachments}
                    attachments={documentAttachments}
                    docId={documentId}
                    previewSettings={previewSettings}
                    onPreviewSettingsChange={onPreviewSettingsChange}
                    layout={layout}
                />
            </div>

            {/* <div
                className="single-document-mobile-nav"
                style={{
                    position: !isScroll ? 'fixed' : 'absolute',
                    bottom: !isScroll ? '63px' : '0px',
                }}
            >
                <a
                    href="/"
                    className={activeTab === 'summary' ? 'active' : ''}
                    onClick={(e) => handleTabChange(e, 'summary')}
                >
                    <List width={'20px'} height={'20px'} />
                </a>
                <a
                    href="/"
                    className={
                        activeTab === 'main' && view === 'variables'
                            ? 'active'
                            : ''
                    }
                    onClick={(e) => handleTabChange(e, 'main')}
                >
                    <Pen width={'20px'} height={'20px'} />
                </a>
                <a
                    href="/"
                    className={
                        activeTab === 'preview' && view === 'variables'
                            ? 'active'
                            : ''
                    }
                    onClick={(e) => handleTabChange(e, 'preview')}
                >
                    <Eye2 width={'20px'} height={'20px'} />
                </a>
                <a
                    href="/"
                    className={
                        (activeTab === 'main' || activeTab === 'preview') &&
                            view === 'attachments'
                            ? 'active'
                            : ''
                    }
                    onClick={(e) => handleTabChange(e, 'main', true)}
                >
                    <Paperclip width={'20px'} height={'20px'} />
                </a>
            </div> */}

            {showAgencyModal && (
                <AgencyModal
                    onClose={handleCloseAgencyModal}
                    onSetDocValues={setDocumentValues}
                    token={token}
                />
            )}

            {showNotariesModal && (
                <NotariesModal
                    onClose={handleCloseNotariesModal}
                    onOpenAddEditNotaryModal={handleOpenAddEditNotaryModal}
                    onSetSelectedNotary={setSelectedNotary}
                />
            )}

            {showAddEditNotaryModal && (
                <AddEditNotaryModal
                    onClose={handleCloseAddEditNotaryModal}
                    mode={notaryMode}
                    notary={selectedNotary}
                />
            )}
            {showEditionWarningModal && (
                <Alert
                    text="Note importante"
                    bodyText="Vous vous apprêtez à passer en mode édition. Immo Docs ne pourra être tenu pour responsable des modifications apportées au document."
                    okBtnText="J'ai compris"
                    showOk={true}
                    onClose={() => setShowEditionWarningModal(false)}
                />
            )}
            {showShareModal && (
                <SingleDocumentShareV2
                    onClose={handleCloseShareModal}
                    attachments={documentAttachments}
                    onAttachmentShareSave={handleAttachmentShareSave}
                    documentName={singleDocName}
                    documentId={params.id}
                    singleDoc={documents[params.id]}
                    template={templateObject}
                    documentValues={documentValues}
                    useCustomCover={useCustomCover}
                    shareAttachments={shareAttachments}
                    contacts={activeDocumentContacts}
                />
            )}

            {showSignModal && (
                <SingleDocumentSignVialink
                    onClose={handleCloseSignModal}
                    documentName={singleDocName}
                    docId={documentId}
                    docAttachments={documentAttachments}
                    docSignatureRecipients={docSignatureRecipients}
                    singleDoc={{
                        ...singleDoc,
                        name: singleDocName,
                        values: documentValues,
                        custom_cover: useCustomCover,
                        id: documentId,
                    }}
                    docContacts={activeDocumentContacts}
                    template={templateObject}
                    renderOptions={renderOptions(singleDoc, templateObject)}
                />
            )}
        </Layout>
    )
}

export default SingleDocument
